module.exports = __webpack_public_path__ + "3f89142a8319d79e7da6444b3fa42deb.svg";